<section class="verify" role="status" aria-live="polite">
  @if (data().message) {
    <p class="verify__message">{{ data().message }}</p>
  }

  <ul class="verify__list">
    @if (email(); as e) {
      <li class="verify__row">
        <div class="verify__row-info">
          <span class="verify__label">Email</span>
          @if (e.value) {
            <span class="verify__value">{{ e.value }}</span>
          }
        </div>
        @if (e.verified === true) {
          <span class="verify__pill verify__pill--ok">Verified</span>
        }
      </li>
    }
    @if (phone(); as p) {
      <li class="verify__row">
        <div class="verify__row-info">
          <span class="verify__label">Phone</span>
          @if (phoneDisplay()) {
            <span class="verify__value">{{ phoneDisplay() }}</span>
          }
        </div>
        @if (p.verified === true) {
          <span class="verify__pill verify__pill--ok">Verified</span>
        }
      </li>
    }
  </ul>

  <div class="verify__actions">
    @if (needsPhone()) {
      <button type="button"
              class="verify__cta verify__cta--filled"
              [disabled]="!interactive()"
              (click)="openPhoneVerify()">
        <svg class="verify__cta-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z"
                stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
        </svg>
        <span>{{ phoneCtaLabel() }}</span>
      </button>
    }
    @if (needsEmail()) {
      <button type="button"
              class="verify__cta verify__cta--outline"
              [disabled]="!interactive()"
              (click)="openEmailVerify()">
        <svg class="verify__cta-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" />
          <path d="m4 7 8 6 8-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>Verify email</span>
      </button>
    }
  </div>
</section>

<ng-template #verifyPhoneTemplate>
  <app-phone-verification-modal
    [prefillPhone]="phone()?.value ?? ''"
    [prefillDialCode]="data().profile.countryCode?.value ?? ''"
    [editablePhone]="phoneEditable()"
    [title]="phoneModalTitle()"
    [description]="phoneModalDescription()"
    (closeModal)="onPhoneVerifyClosed()" />
</ng-template>

<ng-template #verifyEmailTemplate>
  <app-email-verification-modal
    [email]="email()?.value ?? ''"
    title="Verify your email"
    (verified)="onEmailVerified()"
    (closeModal)="onEmailModalClosed()" />
</ng-template>
